<template>
  <div :class="$style.base">
    <IconSearch :isFocussed="focus" :class="$style.icon" />
    <input
      :class="$style.searchInput"
      type="text"
      v-model="searchQuery"
      :placeholder="$t('services.search')"
      :style="`border-bottom-color: ${widgetSettings.color}`"
      @focus="focus = true"
      @blur="focus = false"
      v-test="'services-search'"
    />
  </div>
</template>

<script lang="ts" setup>
import IconSearch from '@/components/IconSearch.vue';
import widgetSettings from '@/widget-settings';
import { computed, ref } from 'vue';

const props = defineProps<{
  modelValue: string;
}>();

const emit = defineEmits(['update:modelValue']);

const focus = ref(false);

const searchQuery = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  }
});
</script>

<style lang="scss" module>
.base {
  position: relative;
  background-color: $color-bg;
}

.icon {
  position: absolute;
  width: 24px;
  top: 50%;
  left: $spacing;
  margin-top: -12px;
  pointer-events: none;
}

.searchInput {
  background-color: $color-bg;
  padding: ($spacing * 1.5) $spacing ($spacing * 1.5) ($spacing * 2 + 24px);
  margin: 0;
  border: none;
  width: 100%;
  font-size: 16px;
  line-height: 18px;
  color: $color-font-dark;
  border-bottom: 1px solid;

  transition: border-color 0.15s;

  &:not(:focus) {
    border-bottom-color: $color-border-input !important;
  }

  &::placeholder {
    color: $color-search-input;
  }

  &:focus {
    outline: none;
  }
}
</style>
